import { FC, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { PageBanner } from '../../components/page-banner/page-banner';
import { MatterNews } from './matter-news/matter-news';
import { getNewDetail } from '../../apis/news';
import { formatNews } from '../../util/news';

export const DynamicNewsContainer: FC = () => {
  const { pathname } = useLocation();
  const [matterApiReposnse, setMatterApiReposnse]: any = useState({
    title: '',
  });
  const segments = pathname.split(/[?#]/)[0].split('/').filter(Boolean);
  const idNew = segments[1];
  const isMounted = useRef(false);

  const getNewDetails = async () => {
    const result = await getNewDetail(idNew);
    const formatted = formatNews(result);
    setMatterApiReposnse(formatted);
  };

  useEffect(() => {
    if (!isMounted.current) {
      getNewDetails();
      isMounted.current = true;
      return;
    }
  }, [idNew, getNewDetails]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <>
      <PageBanner title={matterApiReposnse.title} />

      <MatterNews {...matterApiReposnse} />
    </>
  );
};
